import _isNil from "lodash/isNil";
import "core-js/modules/es7.object.values.js";
import "core-js/modules/es6.array.filter.js";
import FastqFileType from 'const/enums/FastqFileType';
import createMemoizedSelector from '../createMemoizedSelector';
var WT_FASTQ = FastqFileType.WT_FASTQ,
  IMMUNE_FASTQ = FastqFileType.IMMUNE_FASTQ;
var getFastqMatcherInputsSelector = function getFastqMatcherInputsSelector() {
  return function (analysisState) {
    var _files$data;
    if (_isNil(analysisState)) {
      return {
        numOfSublibraries: null,
        pairedWt: false,
        kit: null,
        wtFileCount: 0,
        immuneFileCount: 0
      };
    }
    var numOfSublibraries = analysisState.numOfSublibraries,
      pairedWt = analysisState.pairedWt,
      kit = analysisState.kit,
      files = analysisState.files;
    var fileValues = Object.values((_files$data = files === null || files === void 0 ? void 0 : files.data) !== null && _files$data !== void 0 ? _files$data : {});
    var wtFileCount = fileValues.filter(function (file) {
      return file.type === WT_FASTQ;
    }).length;
    var immuneFileCount = fileValues.filter(function (file) {
      return file.type === IMMUNE_FASTQ;
    }).length;
    return {
      numOfSublibraries: numOfSublibraries,
      pairedWt: pairedWt,
      kit: kit,
      wtFileCount: wtFileCount,
      immuneFileCount: immuneFileCount
    };
  };
};
export default createMemoizedSelector(getFastqMatcherInputsSelector, {
  inputSelectors: [{
    func: function func(secondaryAnalysisId) {
      return function (state) {
        return state[secondaryAnalysisId];
      };
    },
    paramsIngest: function paramsIngest(secondaryAnalysisId) {
      return [secondaryAnalysisId];
    }
  }]
});